<template>
    <section class="row mt-3 section-recruitment">
        <div class="container-fluid">
            <div class="col-10 offset-1 col-lg-2 offset-lg-5">
                <div class="row">
                    <h1 class="section-title text-white">Tuyển dụng</h1>
                </div>
            </div>
            <div class="col-10 offset-1 col-lg-8 offset-lg-2 mt-3">
                <div class="row">
                    <blockquote class="blockquote text-white text-center font-weight-bold">
                        <p>Hoài bão và ước mơ của bạn sẽ được Phượng Hoàng chấp cánh. Tại đây chúng tôi tôn trọng tài năng và luôn mang lại cơ hội để bạn phát triển!</p>
                    </blockquote>
                </div>
            </div>
            <div class="col-10 offset-1 col-lg-2 offset-lg-5 mt-3">
                <div class="row">
                    <router-link :to="{name: 'RecruitmentPageComponent'}" class="btn btn-block btn-danger btn-lg text-white font-weight-bold">Nộp hồ sơ ngay</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "RecruimentComponent"
    }
</script>

<style scoped>

</style>
